import { Theme } from "@mui/material";

export const secondarySurfaceStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.dsSurface.v300,
  color: theme.palette.dsBase.v200,
  "&:hover": {
    backgroundColor: theme.palette.dsSurface.v200,
    color: theme.palette.dsBase.v200,
  },
});

export const outlinedSecondarySurfaceStyles = (theme: Theme) => ({
  ...secondarySurfaceStyles(theme),
  border: `1px solid ${theme.palette.dsBase.v200}10`,
  "&:hover": {
    ...secondarySurfaceStyles(theme)["&:hover"],
  },
});
